import Error from 'components/alerts/Error';
import { Text } from 'components/common/form/modules/input/Text';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { checkInAllTickets, checkInOneTicket, findOrderByCode } from 'components/graphql/queries'
// import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import UserDucks from 'stores/ducks/User.duck';
import TicketQRScanner from './TicketQRScanner';

const Validate: React.FC<{ [label: string]: any }> = (props: any) => {

    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [campaignId] = useState(props.campaignId)
    const [orderId, setOrderId] = useState('')
    const [screenNumber, setScreenNumber] = useState(1)

    const [loading, setLoading] = useState(false)

    const [order, setOrder] = useState({
        buyerEmail: '',
        buyerName: '',
        orderComponents: [
            { name: '', price: 0, count: 0 }
        ],
        campaign: {
            name: '',
            description: '',
            startTime: {
                year: 0,
                month: 0,
                day: 0,
                hour: 0,
                minute: 0,
                PM: true
            },
            media: {
                logo: ''
            },
            floorplan: {
                labels: [],
                inventoryMap: [],
                height: 0,
                width: 0
            }
        },
        boughtAt: new Date(),
        stripeFee: 0,
        platformFee: 0,
        totalCount: 0,
        subtotal: 0,
        code: '',
        floorplanLocation: null
    })

    const onScan = useCallback((code: string) => {

        setError(false)
        setErrorMessage('')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findOrderByCode,
                variables: {
                    code
                }
            })
            .then((res) => {
                if (res.data.data.order.findByCode) {
                    if ((campaignId.toString().trim() === res.data.data.order.findByCode.campaignId.toString().trim())) {
                        // Move on to displaying check-in options
                        setOrder(res.data.data.order.findByCode)
                        setScreenNumber(2)
                    } else {
                        setError(true)
                        setErrorMessage('Order belongs to different event')
                    }
                } else {
                    setError(true)
                    setErrorMessage('Invalid Code')
                }
            })
            .catch((err) => {
                setError(true)
                setErrorMessage('Invalid Code')
            })

    }, [campaignId, setScreenNumber, setError, setErrorMessage])

    const checkInOne = useCallback((inventoryItemId: string) => {
        // params to mutation - order code + inventoryItemId
        // First check-in
        setLoading(true)
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: checkInOneTicket,
                variables: {
                    code: order.code,
                    inventoryItemId
                }
            })
            .then((res) => {
                // Then retrieve order again
                if (res.data.data.order.checkInOneOrderComponent) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: findOrderByCode,
                            variables: {
                                code: order.code
                            }
                        })
                        .then((res2) => {
                            if (res2.data.data.order.findByCode) {
                                setOrder(res2.data.data.order.findByCode)
                                setLoading(false)
                            } else {
                                setError(true)
                                setErrorMessage('Something went wrong')
                                setLoading(false)
                            }
                        })
                        .catch((err) => {
                            setError(true)
                            setErrorMessage('Something went wrong')
                            setLoading(false)
                        })
                } else {
                    setError(true)
                    setErrorMessage('Something went wrong')
                    setLoading(false)
                }
            })
            .catch((err) => {
                setError(true)
                setErrorMessage('Something went wrong')
                setLoading(false)
            })
    }, [order.code, setError, setErrorMessage, setOrder, setLoading])

    const checkInAll = useCallback(() => {
        // params to mutation - order code 
        // First check-in
        setLoading(true)
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: checkInAllTickets,
                variables: {
                    code: order.code
                }
            })
            .then((res) => {
                // Then retrieve order again
                if (res.data.data.order.checkInAllOrderComponents) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: findOrderByCode,
                            variables: {
                                code: order.code
                            }
                        })
                        .then((res2) => {
                            if (res2.data.data.order.findByCode) {
                                setOrder(res2.data.data.order.findByCode)
                                setLoading(false)
                            } else {
                                setError(true)
                                setErrorMessage('Something went wrong')
                                setLoading(false)
                            }
                        })
                        .catch((err) => {
                            setError(true)
                            setErrorMessage('Something went wrong')
                            setLoading(false)
                        })
                } else {
                    setError(true)
                    setErrorMessage('Something went wrong')
                    setLoading(false)
                }
            })
            .catch((err) => {
                setError(true)
                setErrorMessage('Something went wrong')
                setLoading(false)
            })
    }, [order.code, setError, setErrorMessage, setOrder, setLoading])

    useEffect(() => {
        if (orderId.length === 5) {
            onScan(orderId)
        }
    }, [orderId, onScan])


    let numCheckedIn = 0;
    if (order) {
        order.orderComponents.map((item: any) => {
            numCheckedIn += item.validated;
        })
    }

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="p-4 w-100 text-center">
                <ClipLoader color={"#000"} loading={true} />
            </div>
        </div>
    }

    return <div style={{ padding: '20px' }}>
        {/* SCREEN 1 - scan ticket/get ID */}
        {
            screenNumber === 1 ?
                <div style={{ textAlign: 'left' }}>
                    <p className='sexyBlack'>
                        Scan QR Code
                    </p>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <div style={{ width: screen.width > 768 ? '60%' : '80%', paddingBottom: '40px' }}>
                            <TicketQRScanner onScan={(code) => onScan(code)} />
                        </div>
                    </div>
                    <Text
                        key={screenNumber}
                        label='Or Enter 5-Digit Order ID'
                        value={orderId}
                        onChange={e => setOrderId(e.target.value)}
                    />
                </div> : null
        }
        {/* SCREEN 2 - Check-in individual order coponents or the whole thing */}
        {
            screenNumber === 2 ? <div>
                <p>
                    Order <span className='sexyBlack'>
                        #{order.code}
                        &nbsp;</span>
                    {
                        numCheckedIn === order.totalCount ? '(All Items Validated)' : null
                    }
                </p>
                {
                    order.orderComponents.map((orderComp: any) => {
                        const toReturn: any[] = []
                        for (let i = 0; i < orderComp.count; i++) {
                            if (i < orderComp.validated) {
                                toReturn.push(<div style={{ paddingBottom: '25px' }}>
                                    <div style={{ float: 'left' }}>
                                        {
                                            orderComp.name
                                        }
                                    </div>
                                    <div style={{ float: 'right', color: '#1931b9' }}>
                                        &#10003;
                                    </div>
                                </div>)
                            } else {
                                toReturn.push(<div style={{ paddingBottom: '25px' }}>
                                    <div style={{ float: 'left' }}>{
                                        orderComp.name
                                    }
                                    </div>
                                    <div style={{ float: 'right' }}>
                                        <button className='new-button-cancel' onClick={() => checkInOne(orderComp.inventoryItemId)}>
                                            VALIDATE
                                        </button>
                                    </div>
                                </div>)
                            }
                        }
                        return toReturn.map((i: any) => i)
                    })
                }
                {
                    numCheckedIn === order.totalCount ? null :
                        <div style={{ paddingBottom: '25px', paddingTop: '15px' }}>
                            <div style={{ float: 'right' }}>
                                <button className='new-button-cancel' onClick={() => checkInAll()}>
                                    VALIDATE ALL
                        </button>
                            </div>
                        </div>
                }
            </div> : null
        }
        {
            error ?
                <div style={{ padding: '20px' }}>
                    <Error content={errorMessage} />
                </div>
                : null
        }
        {/* <div style={{ width: '100%', textAlign: 'center', paddingTop: '25px' }}>
            <button className='new-button-save' onClick={() => {
                props.reloadData()
                closeModal()
            }}>
                DONE
            </button>
        </div> */}
        {
            screenNumber === 2 ?
                <div style={{ width: '100%', textAlign: 'center', paddingTop: '15px' }}>
                    <button
                        className="new-button-blue-outline"
                        onClick={e => {
                            setScreenNumber(1)
                            setOrderId('')
                        }}
                    >
                        BACK
                </button>
                </div> : null
        }
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(Validate);


// WEBPACK FOOTER //
// ./src/pages/campaign/Checkin/Validate.tsx